import type { WidgetProps } from './WidgetProps'
import { LessonListWidget } from './LessonListWidget'

export function NextLessonsWidget({ payload }: WidgetProps) {
  const lessons = Array.isArray(payload.lessons) ? payload.lessons : []

  return (
    <LessonListWidget
      lessons={lessons}
      emptyKey="dashboard.widgets.next_lessons.empty"
      withDate
    />
  )
}
